import React from 'react';
import Navbar from '../layouts/Navbar';
import Footer from '../layouts/Footer';
import '../styles/Message.css';

const Message = () => {
    return ( 
        <div>
            <Navbar />
            <div className="message-container" dir='rtl'>
                <h1 className="h1">الرؤية والرسالة</h1>
                <div className="message-content">
                    <p className="p1">
                        رؤية جامعة حلوان: تسعى جامعة حلوان أن تكون مؤسسة تعليمية وبحثية رائدة في التكنولوجيا والفنون، ومتميزة في التربية والعلوم وفقاً لمعايير الجودة العالمية.
                    </p>
                    <h1 className="p1">
                        رسالة جامعة حلوان:
                    </h1>
                    <ul className="message-list">
                        <li>تقديم برامج أكاديمية ذات جودة عالية، تحكمها المعايير المحلية والعالمية؛ لإعداد خريج متميز قادر على المنافسة والإبداع، وتلبية حاجات المجتمع، والإسهام في تطوره ورفاهيته.</li>
                        <li>تقديم برامج رفع كفاءة أعضاء هيئة التدريس، وتنمية قدراتهم التعليمية والبحثية؛ حتى ينعكس ذلك إيجابيًا على كل من الطالب والبيئة المحلية والقومية.</li>
                        <li>الارتقاء بالبحث العلمي في الجامعة.</li>
                        <li>تحقيق التعليم المستمر، وزيادة التعاون مع المؤسسات التعليمية العالمية.</li>
                        <li>تحقيق التعليم المشاركة الفعالة في خدمة المجتمع، وبناء ثقافته وتنمية بيئته، ودفع قطاعات الإنتاج فيه للمنافسة المحلية والإقليمية والعالمية.</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
}
 
export default Message;
